export const SENDER_CREATOR = 1;
export const SENDER_CLIENT = 2;
